import React, { useCallback, useEffect, useReducer, useState } from "react"
import {
    obterParametrosClienteFiel,
    atualizarParametrosClienteFiel,
} from "../../../services/configuracaoDeliveryFornecedor"
import useAppStore from "../../../stores/AppStore"
import type { ConfigsType } from "../../../stores/ConfigsStore"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { ParametrosClienteFielInicial } from "../models/parametrosClienteFielModel"
import { ParametrosClienteFielActionsTypes } from "./parametrosClienteFielActions"
import { ParametrosClienteFielContext } from "./ParametrosClienteFielContext"
import { parametrosClienteFielReducer } from "./parametrosClienteFielReducer"

export function ParametrosClienteFielContextProvider({ children }: { children: React.ReactNode }) {
    const [parametros, dispatch] = useReducer(parametrosClienteFielReducer, ParametrosClienteFielInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)
    const atualizarConfiguracoes = useAppStore(s => s.atualizarConfiguracoes)

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterParametrosClienteFiel(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar parâmetros")
            } else {
                setErroCarregamento(null)
                dispatch({
                    type: ParametrosClienteFielActionsTypes.CARREGAR,
                    payload: { ...ParametrosClienteFielInicial, ...response },
                })
            }
        } catch {
            setErroCarregamento("Erro ao carregar parâmetros")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const salvar = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await atualizarParametrosClienteFiel(autorizacao, parametros)
            if ("retornoErro" in response) {
                throw new Error(response.mensagem)
            }
            const atualizados = { ...ParametrosClienteFielInicial, ...response }
            dispatch({
                type: ParametrosClienteFielActionsTypes.CARREGAR,
                payload: atualizados,
            })
            // Sincroniza o tipo de cálculo de entrega no store global. Sem isso, o menu
            // Cadastro > Área de Entrega continuaria roteando pelo valor antigo (ex.: bairros)
            // até a página ser recarregada, ignorando a mudança para "Por distância".
            atualizarConfiguracoes({
                user: { parametros: { calculoEntrega: atualizados.calculoEntrega } },
            } as unknown as ConfigsType)
        } finally {
            setLoading(false)
        }
    }, [parametros, setLoading, atualizarConfiguracoes])

    return (
        <ParametrosClienteFielContext.Provider value={{ parametros, dispatch, salvar, erroCarregamento }}>
            <Loading />
            {children}
        </ParametrosClienteFielContext.Provider>
    )
}
